import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';

import { AiProposalsPage, type AiProposalsSearch } from '../features/ai/ai-proposals-page';

const SearchSchema = z.object({
  page: z.number().int().positive().catch(1),
  pageSize: z.union([z.literal(10), z.literal(25), z.literal(50), z.literal(100)]).catch(25),
  status: z.literal('PENDING_REVIEW').optional().catch(undefined),
});

export const Route = createFileRoute('/manage/$companySlug/projects/$projectId/ai-proposals/')({
  component: RouteComponent,
  validateSearch: zodValidator(SearchSchema),
});

function RouteComponent() {
  const { companySlug, projectId } = Route.useParams();
  const search: AiProposalsSearch = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <AiProposalsPage
      companySlug={companySlug}
      onFilterChange={(status) =>
        void navigate({
          search: (previous) => ({
            page: 1,
            pageSize: previous.pageSize,
            ...(status ? { status } : {}),
          }),
        })
      }
      onPageChange={(page) => void navigate({ search: (previous) => ({ ...previous, page }) })}
      projectId={projectId}
      search={search}
    />
  );
}
